import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import { fetchCaseStatsByTag } from "../../../api/statistics";

export function StatisticsOverview() {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCaseStatsByTag()
      .then((data) => setStats(data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900">
          <ChartBarIcon className="h-5 w-5" />
          {t("Cases by label")}
        </h2>
        <div className="h-32 animate-pulse rounded bg-gray-100" />
      </div>
    );
  }

  const casesByTag = stats?.cases_by_tag ?? [];

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <h2 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900">
        <ChartBarIcon className="h-5 w-5" />
        {t("Cases by label")}
      </h2>
      {casesByTag.length === 0 ? (
        <p className="text-sm text-gray-500">{t("No labels with cases yet")}</p>
      ) : (
        <div className="space-y-3">
          {casesByTag.map((item) => (
            <div
              key={item.tag_id}
              className="flex items-center justify-between rounded-md border border-gray-100 bg-gray-50 px-4 py-2"
            >
              <div className="flex items-center gap-2">
                {item.tag_color && (
                  <span
                    className="h-3 w-3 rounded-full"
                    style={{ backgroundColor: item.tag_color }}
                  />
                )}
                <span className="font-medium text-gray-900">{item.tag_name}</span>
              </div>
              <span className="text-lg font-semibold text-blue-600">
                {item.case_count}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
